import { useEffect } from 'react';
import { useAiSkillsQuery } from './use-gateway-queries';
import { useAiSkillStore } from '../stores/ai-skill-store';

/**
 * useAiSkills — fetches available AI specialist skills and keeps the store in sync.
 *
 * - Fetches from GET /ai-skills on mount (stale-while-revalidate via React Query).
 * - Writes the result into `ai-skill-store.availableSkills` so any component can
 *   read skills without triggering additional network requests.
 * - Returns the query state for loading/error indicators.
 */
export function useAiSkills() {
  const query = useAiSkillsQuery();
  const setAvailableSkills = useAiSkillStore(s => s.setAvailableSkills);

  useEffect(() => {
    if (query.data?.body?.skills) {
      setAvailableSkills(query.data.body.skills as Parameters<typeof setAvailableSkills>[0]);
    }
  }, [query.data, setAvailableSkills]);

  return {
    skills: query.data?.body?.skills ?? [],
    isLoading: query.isPending,
    isError: query.isError,
    error: query.error,
  };
}
